import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import Reveal from "./Reveal";

const FAQS = [
  {
    q: "Do we need to install anything?",
    a: "No. Health Frigate runs in the browser on desktops, tablets and phones. Your admins, doctors and patients each sign in to their own portal.",
  },
  {
    q: "Can it handle both outpatients and inpatients?",
    a: "Yes. OPD appointments, video consults and counter billing sit alongside the inpatient module — bed board, admissions, transfers, daily charges, deposits and discharge with an automatic final bill.",
  },
  {
    q: "We have more than one location. Is that supported?",
    a: "Yes. Each hospital can have multiple locations with their own buildings, wards, beds, services, prices, pharmacies and staff — and owners get a combined view.",
  },
  {
    q: "Is it compliant with ABDM?",
    a: "The platform supports ABHA, HFR and HPR identifiers and stores clinical data as HL7 FHIR R4 resources coded with SNOMED CT, in line with the Ayushman Bharat Digital Mission.",
  },
  {
    q: "How does billing work with GST?",
    a: "Each service, test, package and medicine carries its own price and GST rate. Bills calculate GST per line, accept partial payments and advances (cash, card, UPI or insurance) and track what's still due.",
  },
  {
    q: "How long does it take to get started?",
    a: "Most teams can configure locations, services and doctor rosters and start booking patients within a few days. We help you set it up during the demo.",
  },
];

const Faq = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="py-24 sm:py-28">
      <div className="container-x grid gap-12 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)]">
        <Reveal>
          <span className="eyebrow">FAQ</span>
          <h2 className="section-title">Questions hospitals ask us</h2>
          <p className="mt-4 text-slate-600">
            Can't find what you're looking for? <a href="#contact" className="font-semibold text-brand-700 hover:underline">Talk to our team</a>.
          </p>
        </Reveal>
        <Reveal delay={0.1} className="divide-y divide-slate-200 rounded-2xl border border-slate-200 bg-white">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                >
                  <span className="font-semibold text-ink-900">{f.q}</span>
                  <Plus className={`h-5 w-5 flex-shrink-0 text-brand-600 transition-transform ${isOpen ? "rotate-45" : ""}`} />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.25 }} className="overflow-hidden">
                      <p className="px-6 pb-5 text-slate-600">{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </Reveal>
      </div>
    </section>
  );
};

export default Faq;
